import { inject } from "mobx-react";
import { Fragment } from "react";
import { ResponsiveImage } from "../../../../core/components/ResponsiveImage.component";
import { makeAd, SIT_HEADER_IMAGE, RESPONSIVE_IMAGE } from "@inferno/renderer-shared-core";
import { AdPosition } from "../../../../core/page-blocks/Ad.component";
import { Heading, MagicLink } from "../../../../core/ui";
import { CoastArchiveFeedShowsProps, CoastFeedItemType, getCoastFeedImg } from "../../lib/coastFeed";
import { CoastFeedAds } from "./CoastFeedAds.component";
import { CoastFeedNoResults } from "./CoastFeedNoResults.component";
import { CoastFeedShowItem } from "./CoastFeedShowItem.component";

export const CoastFeedSomewhereInTimeShows = inject("store")(
  ({ block, store, content, title }: CoastArchiveFeedShowsProps) => {
    if (!store) {
      return null;
    }

    const { imgSrc, srcset } = getCoastFeedImg(SIT_HEADER_IMAGE, CoastFeedItemType.SOMEWHERE_IN_TIME, {
      quality: 80,
    });

    return (
      <Fragment>
        <Heading level={2}>{title}</Heading>

        <section className="coast-feed-header">
          <div className="coast-feed-item">
            <figure className="item-thumb">
              <ResponsiveImage
                alt="Somewhere in Time"
                src={imgSrc}
                srcset={srcset}
                initialWidth={RESPONSIVE_IMAGE.responsiveImageInitialWidth}
                initialHeight={RESPONSIVE_IMAGE.responsiveImageInitialHeight}
              />
            </figure>

            <section className="item-summary">
              <Heading level={2}>Somewhere in Time</Heading>
              <p>
                Coast Insiders can now listen to Somewhere In Time via the Coast Player. Check out the{" "}
                <MagicLink to="/art-bell">Art Bell Vault</MagicLink> to listen to hundreds of Art Bell classic shows.
              </p>

              {!store.session.currentSession?.authenticated ? (
                <>
                  Not yet a Coast Insider?&nbsp;
                  <MagicLink className="sign-up" to="/sign-up/">
                    Get Access
                  </MagicLink>
                </>
              ) : null}
            </section>
          </div>

          <AdPosition block={makeAd("3308", 0)} batchId="first-item" />
        </section>

        {content?.length ? (
          <div className="feed-cards">
            {content.map((item, itemIdx) => (
              <Fragment key={item.id}>
                <CoastFeedShowItem item={item} type={CoastFeedItemType.SOMEWHERE_IN_TIME} />
                <CoastFeedAds
                  blockSize={block.value.size}
                  itemCount={content.length}
                  blockId={block.id}
                  itemIdx={itemIdx}
                />
              </Fragment>
            ))}
          </div>
        ) : (
          <CoastFeedNoResults />
        )}
      </Fragment>
    );
  },
);

export default CoastFeedSomewhereInTimeShows;
